import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOtherMaterialReceiveDetail, receiveOtherMaterial, refundOtherMaterial } from '../api/index.js';
import MaterialSelectDrawer from './materialSelectDrawer.vue';
export default {
  name: 'MaterialReceiveRefundDrawer',
  components: {
    MaterialSelectDrawer: MaterialSelectDrawer
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    action: {
      type: String,
      default: 'receive',
      validator: function validator(v) {
        return ['receive', 'refund'].includes(v);
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      drawerSelect: false,
      excludedIds: [],
      form: {
        user_name: '',
        date: '',
        remark: '',
        material_items: []
      },
      receivePage: {},
      allMaterialItems: []
    };
  },
  computed: {
    isRefund: function isRefund() {
      return this.action === 'refund';
    }
  },
  created: function created() {
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;
      this.loading = true;
      getOtherMaterialReceiveDetail({
        id: this.id
      }).then(function (res) {
        var info = res.data && res.data.user_info ? res.data.user_info : {};
        var list = res.data && res.data.list || [];
        _this.form.user_name = info.user_name;
        _this.form.date = info.date || '';
        _this.form.remark = info.remark || '';
        _this.form.material_items = list;
        _this.receivePage = res.pages;
      }).catch(function () {
        _this.$message.error('详情加载失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    getReturnableNum: function getReturnableNum(row) {
      var receive = Number(row.receive_num) || 0;
      var refunded = Number(row.refund_num) || 0;
      return Math.max(receive - refunded, 0);
    },
    validateReturnNum: function validateReturnNum(rule, value, cb, row) {
      if (value === '' || value === null || value === undefined) {
        return cb();
      }
      var num = Number(value);
      if (!/^[1-9]\d*$/.test(String(value))) {
        return cb();
      }
      var max = this.getReturnableNum(row);
      if (num > max) {
        return cb(new Error("\u672C\u6B21\u9000\u8FD8\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7\u53EF\u9000\u8FD8\u6570\u91CF ".concat(max)));
      }
      cb();
    },
    validateReceiveNum: function validateReceiveNum(rule, value, cb, row) {
      if (value === '' || value === null || value === undefined) {
        return cb();
      }
      if (!/^[1-9]\d*$/.test(String(value))) {
        return cb();
      }
      var num = Number(value);
      var stock = Number(row.stock_num) || 0;
      var apply = Number(row.apply_num) || 0;
      if (stock && num > stock) {
        return cb(new Error("\u9886\u53D6\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7\u5E93\u5B58 ".concat(stock)));
      }
      if (apply && num > apply) {
        return cb(new Error("\u9886\u53D6\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7\u7533\u8BF7\u6570\u91CF ".concat(apply)));
      }
      cb();
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var hasReturn = _this2.form.material_items.some(function (item) {
          return Number(item.num) > 0;
        });
        if (!hasReturn) {
          _this2.$message.warning('请至少填写一个物料的数量');
          return;
        }
        // 领取模式下，申请数量与领取数量不一致的物料需二次确认，全部一致则直接提交
        if (!_this2.isRefund) {
          // 申请数量为空或0时不参与比较（不提示）
          var inconsistent = _this2.form.material_items.filter(function (item) {
            var applyNum = item.apply_num;
            if (applyNum === '' || applyNum === null || applyNum === undefined || Number(applyNum) === 0) return false;
            return String(applyNum) !== String(item.num);
          });
          if (inconsistent.length > 0) {
            var names = inconsistent.map(function (item) {
              return item.name;
            }).join('、');
            _this2.$confirm("<span style=\"color: red\">\u3010".concat(names, "\u3011</span> \u7684\u7533\u8BF7\u6570\u91CF\u548C\u9886\u53D6\u6570\u91CF\u4E0D\u4E00\u81F4\uFF0C\u786E\u5B9A\u8981\u63D0\u4EA4\uFF1F"), '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(function () {
              _this2.doSubmit();
            }).catch(function () {});
            return;
          }
        }
        _this2.doSubmit();
      });
    },
    // 组装参数并调用提交接口
    doSubmit: function doSubmit() {
      var _this3 = this;
      var submitFn = this.isRefund ? refundOtherMaterial : receiveOtherMaterial;
      var submitData = {
        id: this.id,
        remark: this.form.remark,
        date: this.form.date,
        material_items: this.form.material_items.map(function (item) {
          return {
            material_stock_id: item.material_stock_id,
            id: item.id,
            num: _this3.isRefund ? item.num : item.num
          };
        })
      };
      this.submitLoading = true;
      submitFn(submitData).then(function () {
        _this3.$message.success(_this3.isRefund ? '退还成功' : '领取成功');
        _this3.$emit('emitGetList');
        _this3.$emit('close');
      }).finally(function () {
        _this3.submitLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleAddMaterial: function handleAddMaterial() {
      this.excludedIds = (this.form.material_items || []).map(function (item) {
        return item.id;
      }).filter(Boolean);
      this.drawerSelect = true;
    },
    handleMaterialSelected: function handleMaterialSelected(materials) {
      var _this4 = this;
      // 追加而非替换：按 id 去重（同一物料编码在不同仓库是不同记录），过滤后追加到明细列表尾部
      var list = (materials || []).filter(function (item) {
        return !_this4.form.material_items.some(function (m) {
          return m.id === item.id;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          num: ''
        });
      });
      this.form.material_items = [].concat(_toConsumableArray(this.form.material_items), _toConsumableArray(list));
      this.drawerSelect = false;
    },
    handleRemove: function handleRemove(index) {
      this.form.material_items.splice(index, 1);
    },
    onReceivePageChange: function onReceivePageChange(val) {
      this.receivePage.page = val;
      this.applyPagination();
    },
    onReceiveSizeChange: function onReceiveSizeChange(val) {
      this.receivePage.size = val;
      this.receivePage.page = 1;
      this.applyPagination();
    }
  }
};